import { getRequests } from "store/thunks/reguests";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IAllRequestsParams {
  pageNumber: number;
  pageSize: number;
  filter?: {
    name?: string | null;
    status?: string | null;
    createdDateTime?: string | null;
  };
}

export interface IAllRequestsResponse<T = any> {
  data: T;
  loading: boolean;
  error: any;
}

export interface IAllRequests<T = any> {
  params: IAllRequestsParams;
  response: IAllRequestsResponse<T>;
}

interface IInitialState {
  allRequests: IAllRequests<any>;
}

const initialState: IInitialState = {
  allRequests: {
    params: {
      pageNumber: 1,
      pageSize: 10,
      filter: {
        name: "",
        status: "",
        createdDateTime: "",
      },
    },
    response: {
      data: [],
      loading: false,
      error: null,
    }
  },
};

const requestsSlice = createSlice({
  name: "requests",
  initialState,
  reducers: {
    setAllRequestsPage: (state, action: PayloadAction<number>) => {
      state.allRequests.params.pageNumber = action.payload;
    },
    setAllRequestsPageSize: (state, action: PayloadAction<number>) => {
      state.allRequests.params.pageSize = action.payload;
      state.allRequests.params.pageNumber = 1;
    },
    setAllRequestsFilter: (state, action) => {
      state.allRequests.params.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRequests.pending, (state) => {
        state.allRequests.response.loading = true;
        state.allRequests.response.error = null;
      })
      .addCase(getRequests.fulfilled, (state, action) => {
        state.allRequests.response.loading = false;
        state.allRequests.response.data = action.payload;
      })
      .addCase(getRequests.rejected, (state, action) => {
        state.allRequests.response.loading = false;
        state.allRequests.response.error = action.payload || "Ошибка загрузки";
      });
  },
});

export const { setAllRequestsPage, setAllRequestsPageSize, setAllRequestsFilter } = requestsSlice.actions;

export default requestsSlice.reducer;
